<template>
  <section class="khonsu-team">
    <div class="container khonsu-team__intro-container">
      <div class="khonsu-team__intro">
        <h2 class="khonsu-team__heading">The Khonsu team</h2>

        <p class="body-copy body-copy--align-center khonsu-team__copy">
          Khonsu’s founders are three IP professionals with over 60 years’
          experience of working in the trademark field. All three believe in
          starting with what they know: the trademark lifecycle from creation to
          exploitation. They have extensive experience of working with design
          agencies, marketing departments and in-house IP teams and have built a
          tool that puts the user firmly in the driving seat.
        </p>
      </div>
    </div>

    <div class="container container--mw-xxl khonsu-team__cards-container">
      <div class="row m-0 khonsu-team__cards-row">
        <div class="col p-0 khonsu-team__cards-column">
          <TextBlock :heading="'LEGAL'">
            <p class="body-copy body-copy--align-center">
              Little bit of info about what you can find here
            </p>
          </TextBlock>
        </div>

        <div class="col p-0 khonsu-team__cards-column">
          <TextBlock :heading="'JOBS'">
            <p class="body-copy body-copy--align-center">
              Think you’ve got what it takes to make this website stellar? By
              all means send us a CV as we’re keen to welcome a young developer
              onto the team.
            </p>
          </TextBlock>
        </div>

        <div class="col p-0 khonsu-team__cards-column">
          <TextBlock :heading="'CASE STUDIES'">
            <p class="body-copy body-copy--align-center">
              Here you’ll find some useful guides to working inside of the
              Khonsu Brand Lab. Quick demos of the
              <span class="fw-700">CREATE</span> and
              <span class="fw-700">CHECK</span> tools together with a
              no-nonsense guide on how to determine what class of goods your
              product or service falls into (important if you want to run a
              secure your new brand name as a trademark).
            </p>
          </TextBlock>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TextBlock from "@/components/blocks/TextBlock";

export default {
  name: "KhonsuTeam",
  components: {
    TextBlock,
  },
};
</script>
